/** Withdraws **/
$('[data-bind="api"]').on('click', function(e) {
    e.preventDefault();

    let el = $(this);
    let msg = '';

    if(el.data('method') === 'cancel') {
        msg = prompt("Причина отмены?", "Проверьте номер кошелька");
        if(!msg) return false;
    }

    axios.post('/' + el.data('type'), {
        method: el.data('method'),
        message: msg,
        id:  el.data('id')
    })
        .then(function (response) {
            if(response.data.result === 'success') {
                $('#w-' + el.data('id')).fadeTo(200, '0.5').find('.btns a').remove();
            }
        })
        .catch(function (error) {
            //console.log(error);
        });
});

/** User page**/
$('[data-clear]').on('click', function() {

    let user_id = $('#user_id').val();
    let link    = $(this).parent('p');

    axios.put('/users/' + user_id, {
        type: $(this).data('clear'),
        item: $(this).data('item')
    })
        .then(function (response) {
            if(response.data.result === 'success') {
                $('#clear-success').fadeIn(200, function(){
                    setTimeout(() => {
                        $('#clear-success').fadeOut(200);
                    }, 2000);
                });
                $(link).hide(100);
            }
        })
        .catch(function (error) {
            $('#clear-error').fadeIn(200, function(){
                setTimeout(() => {
                    $('#clear-error').fadeOut(200);
                }, 2000);
            });
        });

    return false;
});
